import { render, staticRenderFns } from "./CompilanceSanctionList.vue?vue&type=template&id=dd87dbd4&scoped=true"
import script from "./CompilanceSanctionList.vue?vue&type=script&lang=js"
export * from "./CompilanceSanctionList.vue?vue&type=script&lang=js"
import style0 from "./CompilanceSanctionList.vue?vue&type=style&index=0&id=dd87dbd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd87dbd4",
  null
  
)

export default component.exports